import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'typical-problems',
    pluginName: 'SETTINGS',
    entityName: 'TYPICAL_PROBLEM',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch typical problems action creators
export const fetchTypicalProblemInit = () => {
    return crudActions.fetchInit();
};
export const fetchTypicalProblemStart = () => {
    return crudActions.fetchStart();
};
export const fetchTypicalProblemSuccess = () => {
    return crudActions.fetchSuccess();
};
export const fetchTypicalProblemFail = () => {
    return crudActions.fetchFail();
};
export const fetchTypicalProblemCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let countRes = await rest.post("typical-problems/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                }
                return countRes.data.result.data
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch typical problems."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch typical problems."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchTypicalProblem = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let listRes = await rest.post("typical-problems/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                return listRes.data.result.data
            }
            return []

        } catch (error) {
            return []
        }
    }
}

// Load typical problem action creators
export const loadTypicalProblemInit = () => {
    return crudActions.loadInit();
};
export const loadTypicalProblemStart = () => {
    return crudActions.loadStart();
};
export const loadTypicalProblemSuccess = loadedTypicalProblem => {
    return crudActions.loadSuccess(loadedTypicalProblem);
};
export const loadTypicalProblemFail = error => {
    return crudActions.loadFail(error);
};
export const loadTypicalProblem = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};

export const createTypicalProblem = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/typical-problems/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created typical problems.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create typical problems."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const editTypicalProblem = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/typical-problems/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated typical problem.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit typical problem."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const editTypicalProblemVisibility = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/typical-problems/update-visibility', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated visibility of typical problem.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot update visibility of typical problem."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}



// Bulk delete typical problems action creators
export const bulkDeleteTypicalProblemsInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteTypicalProblemsStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteTypicalProblemsSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteTypicalProblemsFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteTypicalProblems = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteTypicalProblemsStart());
        try {
            let res = await rest.post('/typical-problems/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteTypicalProblemsSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted typical problems.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteTypicalProblemsFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete typical problems."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete typical problems."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteTypicalProblemsFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

export const bulkVisibilityEditTypicalProblems = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/typical-problems/bulk-visibility-update', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated visibility of typical problems.`,
                    options: {
                        variant: 'success'
                    }
                });
                return;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot update visibility of typical problems."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// custom functions 
export const fetchGrades = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/grades/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const grades = [];
                for (var grade of res.data.result.data) {
                    grades.push({ value: grade.GradeID, displayValue: grade.InternationalGrading });
                }
                return grades;
            }
            else {

                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list grades."}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}


// Currently on monolith and hence underscore is used in route(TODO-> change after it is moved to SECURAZE-CORE)
export const fetchGradingCategories = (id) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/grading_category/list', { listAll: true, ...id });
            if (res.data && res.data.succeeded) {
                const grades = [];
                for (var grade of res.data.result.data) {
                    grades.push({ value: `${grade.GradingCategoryID}`, displayValue: grade.Product });
                }
                return grades;
            }
            else {

                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list grading categories."}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
}

export const uploadTypicalProblemsStart = () => {
    return {
        type: 'UPLOAD_TYPICAL_PROBLEMS_START',
    };
};
export const uploadTypicalProblemsSuccess = () => {
    return {
        type: 'UPLOAD_TYPICAL_PROBLEMS_SUCCESS',
    };
};
export const uploadTypicalProblemsFail = () => {
    return {
        type: 'UPLOAD_TYPICAL_PROBLEMS_FAIL',
    };
};

export const uploadProgress = (data) => {
    return {
        type: 'TYPICAL_PROBLEMS|PROGRESS',
        progress: data.progress,
        loadSize: data.loadSize,
        maxSize: data.maxSize,
        snackStart: data.snackStart

    };
};


export const uploadTypicalProblems = data => {
    const rest = getAxiosInstance();

    return async dispatch => {
        try {
            const config = {
                onUploadProgress: progressEvent => {
                    dispatch(uploadProgress({ progress: Math.round((progressEvent.loaded * 100) / data.get('File').size), loadSize: Math.round((progressEvent.loaded / 1048576)), maxSize: Math.round((progressEvent.total / 1048576)), snackStart: true }))
                }
            }
            dispatch(uploadTypicalProblemsStart())
            let res = await rest.post('typical-problems/import', data, config);
            if (res.data.status === 200) {
                dispatch(uploadTypicalProblemsSuccess())
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                dispatch(uploadProgress({ progress: 100, loadSize: 0, maxSize: 0, snackStart: false }));


                return res.data.status === 200;
            }
            else {
                dispatch(uploadTypicalProblemsFail());
                dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }))

                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list delivery notes  "}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return false;
            }
        } catch (error) {
            dispatch(uploadTypicalProblemsFail());
            dispatch(uploadProgress({ progress: 0, loadSize: 0, maxSize: 0, snackStart: false }))

            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
}
